module.exports = __webpack_public_path__ + "media/images/header/logo2-c96ed294500b69d5859f04050f860fb6.png";